import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitchPublicRoutes"] */ "/app/packages/frontend/src/components/LanguageSwitchPublicRoutes/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/app/packages/frontend/src/components/SignInForm/index.tsx");
